import type { CitationPillBlock } from "@netsuite-ai/types";
import { openRecord } from "../../lib/host-bridge";

interface Props {
  block: CitationPillBlock;
}

export function CitationPill({ block }: Props) {
  return (
    <button
      onClick={() => openRecord(block.recordId, block.recordType)}
      className="mx-0.5 inline-flex items-center gap-1.5 rounded-full border border-ink/20 bg-surface p-2 text-xs text-ink hover:bg-ink/6 active:bg-ink/12"
    >
      <span className="rounded-full bg-info/40 px-2 py-1.5 font-medium">
        {block.recordType}
      </span>
      <span className="text-ink/50">{block.recordId}</span>
      <span className="font-medium">{block.label}</span>
    </button>
  );
}
